export const FOCUS_EVENT = 0
export const RECONNECT_EVENT = 1
export const MUTATE_EVENT = 2
